'use client';
import React, { useEffect, useState } from 'react';
import { Box, Button, Modal, Popover, Typography } from '@mui/material';
import DTag from '../../dynamic_tag';
import ClientComponent from '@/components/builder/client_component';
import { useSelect } from '@react-three/drei';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 550,
  bgcolor: '#fff',
  boxShadow: 'none',
  borderRadius: '8px',
  maxWidth: '90%',
  padding: '30px'                                 
} ;

const PopUpComponent = ({heading, text, saveAndExit, value, saveAndMoveNext}: any) => {
  
  const [open,setOpen] = useState(true);
  return (
  <Modal
        open={open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className='continue-modal'
      >
        <Box component={"div"} sx={style}>
            <Box component={"div"} className="modal-content-wrapper">
              <Box component={"div"} className='heading'>{heading}</Box>
              <Box component={"span"}>{text}</Box>
            </Box>
            <Box component={"div"} className="cta-wrapper">
              <Button className="save-and-exit-button" onClick={() => { setOpen(false); saveAndExit()}} 
                sx={{
                  backgroundColor: 'primary.light',
                  '&:hover': {
                      backgroundColor: 'primary.light' 
                  },
                  borderColor: 'primary.main'
                }}>
                Save and exit
              </Button> 
              <Button className="next-button"onClick={()=>{ setOpen(false); saveAndMoveNext(false, true,true)}} 
                sx={{
                      backgroundColor: 'primary.main',
                      '&:hover': {
                          backgroundColor: 'primary.main' 
                      }
                }}>
                Continue
              </Button>
            </Box>    
        </Box>
      </Modal>
  )
  
  
  // const [anchorEl, setAnchorEl] = React.useState(value);
  //   const container = document.createElement('div');
  
  //   const handleClose = () => {
  //     //setAnchorEl(null);
  //   };
  
  //   const open = Boolean(anchorEl);
  //   const id = open ? 'simple-popover' : undefined;
  
  //   useEffect(()=>{
  //     document.body.append(container);
  //   },[])
  
  //   useEffect(()=>{
  //     return () => {
  //       document.body.removeChild(container);
  //     }
  //   },[])
  
  //   return (
  //     <>
  //     { 
  //     <Popover
  //         id={id}
  //         open={open}
  //         anchorEl={anchorEl}
  //         onClose={handleClose}
  //         anchorOrigin={{
  //           vertical: 'center',
  //           horizontal: 'center',
  //         }}
  //         transformOrigin={{
  //           vertical: 'top',
  //           horizontal: 'center',
  //         }}
  //       >
  //         <div style={{ padding: '16px', textAlign: "center" }}>
  //           <h4 style={{fontWeight: 700,fontSize:"24px",lineHeight:"36px",letterSpacing:"-1.5%"}}>{heading}</h4>
  //           <p style={{fontWeight: 400,fontSize:"18px",lineHeight:"30px",letterSpacing:"-1.5%"}}>{text}</p>
  
  //           <footer className="overly-footer" style={{textAlign: "center"}}>
  //                 <DTag as="button" className="save-and-exit-button button" onClick={saveAndExit}>
  //                     Save and exit
  //                 </DTag>
  //                 <DTag as="button" className="next-button button" onClick={()=>saveAndMoveNext(false, true)}>
  //                     Continue
  //                 </DTag>
  //         </footer>
  //         </div>
  
  //       </Popover>
  //     }
  //  </>
   // );
  };

  export default ClientComponent(PopUpComponent);